import React, { useContext } from "react";
import { useOutletContext } from "react-router-dom";

import AppContext from "../../../../AppContext";
import { IFlowStepProps } from "../../../Types/IFlow";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import QualifyStep, { IQualifyStepConfig } from "../Components/QualifyStep";
import QualifyStepForm from "../Components/QualifyStepForm";
import QualifyStepFormValidatorCache from "../Components/QualifyStepFormValidatorCache";
import QualifyStepWrapper, { IQualifyStepWrapperConfig } from "../Components/QualifyStepWrapper";
import useCreateNonCandidateContactResult from "../Hooks/UseCreateNonCandidateContactResult";
import useUpdatePatient from "../Hooks/UseUpdatePatient";

const CachedQualifyForm: IQualifyStepConfig["Form"] = props => (
  <QualifyStepFormValidatorCache {...props} Form={QualifyStepForm} />
);

const ComposedQualifyStep: IQualifyStepWrapperConfig["QualifyStep"] = props => (
  <QualifyStep {...props} Form={CachedQualifyForm} />
);

const AppContextQualifyStep: React.FC<IStepWrapperButtonProps> = props => {
  const flowStepProps = useOutletContext<IFlowStepProps>();
  const {
    patient,
    defaultCenter,
    bookingController,
    disqualifyingReasonsCState,
    contactId,
    setPatient,
    setContactResult,
    triggerSavePatientNote
  } = useContext(AppContext);
  return (
    <QualifyStepWrapper
      {...props}
      {...flowStepProps}
      patient={patient}
      defaultCenter={defaultCenter}
      bookingController={bookingController}
      disqualifyingReasons={disqualifyingReasonsCState || null}
      contactId={contactId}
      setPatient={setPatient}
      setContactResult={setContactResult}
      QualifyStep={ComposedQualifyStep}
      onNonCandidateDisqualification={triggerSavePatientNote}
      UseCreateNonCandidateContactResult={useCreateNonCandidateContactResult}
      UseUpdatePatient={useUpdatePatient}
    />
  );
};

export default AppContextQualifyStep;
